import React, { useState } from 'react';
import s from './CardOrganization.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import ButtonSecondaryEllipse from '../ButtonSecondaryEllipse/ButtonSecondaryEllipse';
import GradientBlurb from '../GradientBlurb/GradientBlurb';
import PhotoCred from '../PhotoCred';
import ButtonPrimaryEllipse from '../ButtonPrimaryEllipse/ButtonPrimaryEllipse';
import getFocalImageStyles from '../../utils/getFocalImageStyles';

const CardOrganization = ({
  title = '',
  text = '',
  image = null,
  href = '',
  subjects = [],
  isLoading = false,
}) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const [isHovered, setIsHovered] = useState(false);

  const classes = classNames(s.Root, {
    [s.Loaded]: inView,
    [s.Loader]: isLoading,
  });

  const imageStyle = getFocalImageStyles(image);

  const normalizedHref =
    href && !href.startsWith('http') ? `https://${href}` : href;

  return (
    <div
      className={classes}
      ref={ref}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {!!href && (
        <a
          className={s.Link}
          href={normalizedHref}
          target="_blank"
          rel="noopener noreferrer">
          <span className="sr-only">{title}</span>
        </a>
      )}
      <div className={s.Container}>
        {image?.url && (
          <div className={s.ImageContainer}>
            <Image
              className={s.Image}
              src={image?.url}
              alt={image?.alt}
              fill
              style={imageStyle}
            />
            <PhotoCred credit={image?.credit} />
          </div>
        )}
        <div className={s.Content}>
          <h3 className={s.Title}>{title}</h3>
          <p className={s.Text}>{text}</p>
          <div className={s.BottomWrapper}>
            {subjects.length > 0 && (
              <ul className={s.Subcategories}>
                {subjects.map((subject) => (
                  <React.Fragment key={subject.slug}>
                    <li className={`black-glass ${s.Subcategory}`}>
                      {subject.title}
                    </li>

                    {subject.children.map((child) => (
                      <li
                        key={child.slug}
                        className={`black-glass ${s.Subcategory}`}>
                        {child.title}
                      </li>
                    ))}
                  </React.Fragment>
                ))}
              </ul>
            )}

            <div className={s.Button}>
              <ButtonPrimaryEllipse
                animateIcon
                icon="icon-external-white"
                isHovered={isHovered}
                tabIndex={-1}
                aria-hidden={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CardOrganization.propTypes = {};

export default CardOrganization;
